import * as React from "react";
import { Route, Switch } from "react-router-dom";

import { CheckoutPage, ConfirmationPage } from "../../../components/pages";
import { CenteredTemplate } from "../../../components/templates/centered";

interface IProps {
  path: string;
}

const BookingPage: React.FC<IProps> = ({ path }) => {
  return (
    <CenteredTemplate>
      <Switch>
        <Route
          exact
          path={`${path}/confirmation`}
          render={() => <ConfirmationPage />}
        />
        <Route path={`${path}`} render={() => <CheckoutPage path={path} />} />
      </Switch>
    </CenteredTemplate>
  );
};

export { BookingPage };
